import { twoImageTheme } from './themes/twoImageTheme'

export const defaultTheme = twoImageTheme
